import React from "react";
import {
  Paper,
  Popper,
  Grow,
  ClickAwayListener,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Typography,
  Badge
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Feedback } from "@material-ui/icons";
import FiberManualRecord from '@material-ui/icons/FiberManualRecord'
import db from "../db.js";
const data = db();
const improvements = data.improvements;

const styles = theme => ({
  primary: {
    color: theme.palette.secondary.light
  },
  cont:{
    display: "block",
    marginBottom: 10,
  },
  icon:{
    color: "#ffffff"
  },
  icon_purple:{
    color: theme.palette.primary.main,
    width: 14
  },
  button:{
    marginTop: 4
  },
  mainArea:{
    width: 600,
  },
  overflowArea:{
    overflowY: 'scroll',
    overflowX: 'hidden',
    maxHeight: 580,
  },
  title:{
    textAlign: 'center',
    paddingTop: 18,
    fontWeight: '500',
    marginBottom: 15,
    color: theme.palette.primary.main
  },
  paddingList:{
    paddingLeft: 0,
  },
  badge:{
    '& span': {
      backgroundColor: '#e8c239 !important',
      width: '12px !important',
      height: '12px !important',
    }
  },
});

class NotificationsArea extends React.Component {
  state = {
    open: false,
  };

  handleMenu = event => {
    if(!this.props.readNotifications){
     this.props.setReadNotifications();
    }

    this.setState(state => ({ open: !state.open }));

  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  render() {
    const { classes, isOpen, readNotifications } = this.props;
    const { open } = this.state;

    return (
      <div data-tut="notification">
        <IconButton
          className={classes.button}
          onClick={this.handleMenu}
          buttonRef={node => {
            this.anchorEl = node;
          }}>
          <Badge variant="dot" className={classes.badge} badgeContent={readNotifications || open? 0 : 1}>
            <Feedback className={classes.icon} />
          </Badge>
        </IconButton>
        <Popper open={open || isOpen} anchorEl={this.anchorEl} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow {...TransitionProps}>
              <Paper className={classes.mainArea}>
                <ClickAwayListener onClickAway={this.handleClose}>
                  <React.Fragment>
                  <Typography variant="h5" className={classes.title}>
                    Nuevas funcionalidades
                  </Typography>
                  <Divider/>
                  <List component="nav" className={classes.overflowArea}>
                    {improvements.map((improvement) => {
                      return(
                        <React.Fragment key={improvement.title}>
                          <ListItem key={improvement.title}>
                            <ListItemIcon>
                              <FiberManualRecord className={classes.icon_purple}/>
                            </ListItemIcon>
                            <ListItemText
                              className={classes.paddingList}
                              primary={improvement.title}
                              secondary={
                                improvement.content.map((cont => {
                                  return (<span className={classes.cont} key={Math.floor(Math.random()*1000)}>{cont}</span>)
                                }))
                              }
                            />
                          </ListItem>
                          <Divider/>
                        </React.Fragment>
                      )
                    })}

                  </List>
                  </React.Fragment>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(NotificationsArea);



// WEBPACK FOOTER //
// ./src/components/NotificationsArea.js